module.exports = __webpack_public_path__ + "img/gy5.3b694def.png";